export const lang = {
  title: "入驻信息"
}
